(function () {
  var hashChangeBound = false;

  function initFeaturedCollectionVideoModals(root) {
    if (!root || root.dataset.fcVideoModalsInit) return;
    root.dataset.fcVideoModalsInit = 'true';

    var overlays = root.querySelectorAll('.video-overlay');
    var modals = root.querySelectorAll('.modal');
    var scrollPosition = 0;
    var activeModal = null;

    overlays.forEach(function (overlay, index) {
      overlay.addEventListener('click', function () {
        var container = overlay.closest('.video-container');
        if (container) {
          var id = container.dataset.id;
          var modalLink = overlay.getAttribute('href');
          if (id && modalLink) {
            var iframe = document.querySelector(modalLink + ' iframe');
            if (iframe) {
              iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
            }
          }
        }

        if (!isModalOpen()) {
          scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
          activeModal = modals[index];
          activeModal.style.display = 'block';
          document.body.style.overflow = 'hidden';
          updateUrlHash(activeModal.id);
        }
      });
    });

    modals.forEach(function (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          closeModal(modal);
        }
      });

      var closeButton = modal.querySelector('.close');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          if (activeModal === modal) {
            closeModal(modal);
            activeModal = null;
            restoreScrollPosition();
          }
        });
      }
    });

    if (!hashChangeBound) {
      hashChangeBound = true;
      window.addEventListener('hashchange', function () {
        var newHash = window.location.hash.slice(1);
        var modal = document.getElementById(newHash);

        if (modal && modal.classList.contains('modal') && root.contains(modal)) {
          activeModal = modal;
          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
        } else if (activeModal && root.contains(activeModal)) {
          closeModal(activeModal);
          activeModal = null;
          restoreScrollPosition();
        }
      });
    }

    function isModalOpen() {
      return activeModal !== null;
    }

    function closeModal(modal) {
      var videoFrame = modal.querySelector('.video-best-modal iframe');

      if (videoFrame) {
        var videoSrc = videoFrame.src;
        videoFrame.src = '';
        videoFrame.src = videoSrc;
      }

      modal.style.display = 'none';
      document.body.style.overflow = 'visible';
    }

    function updateUrlHash(hash) {
      window.location.hash = hash;
    }

    function restoreScrollPosition() {
      window.scrollTo(0, scrollPosition);
    }
  }

  function initFeaturedCollectionReadMore(root) {
    if (!root || root.dataset.fcReadMoreInit) return;
    root.dataset.fcReadMoreInit = 'true';
    root.querySelectorAll('.card-text-fc').forEach(function (element) {
      var text = element.textContent;
      var charCount = text.length;
      var maxChars = 200;

      if (!element.dataset.buttonAdded && charCount > maxChars) {
        var button = document.createElement('button');
        button.className = 'btn-read-more-fc';
        button.textContent = 'Czytaj więcej';
        element.after(button);
        element.dataset.buttonAdded = 'true';

        button.addEventListener('click', function () {
          element.classList.toggle('expanded');
          if (element.classList.contains('expanded')) {
            element.style.maxHeight = element.scrollHeight + 'px';
            button.textContent = 'Czytaj mniej';
          } else {
            element.style.maxHeight = '70px';
            button.textContent = 'Czytaj więcej';
          }
        });
      }
    });
  }

  function initFeaturedCollectionProductRandomize() {
    document.querySelectorAll('[data-randomize-products="true"]:not([data-randomized])').forEach(function (productList) {
      productList.dataset.randomized = 'true';
      var productItems = Array.prototype.slice.call(productList.querySelectorAll('.random-product-item'));
      if (!productItems.length) return;

      var displayLimit = parseInt(productList.getAttribute('data-products-limit'), 10) || 4;
      var shuffled = productItems.sort(function () { return 0.5 - Math.random(); });
      var selected = shuffled.slice(0, displayLimit);

      productList.innerHTML = '';
      selected.forEach(function (item) {
        item.classList.remove('hidden');
        productList.appendChild(item);
      });
    });
  }

  function initFeaturedCollectionVideo() {
    var root = document.getElementById('collection-video');
    if (!root) return;

    initFeaturedCollectionProductRandomize();
    initFeaturedCollectionVideoModals(root);
    initFeaturedCollectionReadMore(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionVideo);
  } else {
    initFeaturedCollectionVideo();
  }
})();
